// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"of","play":"pf"};